import { render, staticRenderFns } from "./IconEvents.vue?vue&type=template&id=6a344bad&"
import script from "./IconEvents.vue?vue&type=script&lang=ts&"
export * from "./IconEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports